import clsx from 'clsx';

import type { SDSImageProps } from '@repo/sds/components/SDSImage';
import { SDSImage } from '@repo/sds/components/SDSImage';

import '@repo/sds/components/SDSCircularImage/SDSCircularImage.scss';

export interface SDSCircularImageProps extends Omit<SDSImageProps, 'wrapperClassName'> {
  size?: string | number;
}

export function SDSCircularImage({ size, className, ...imageProps }: SDSCircularImageProps) {
  const style = size
    ? {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
      }
    : undefined;

  return (
    <div className="SDSCircularImage" style={style}>
      <SDSImage {...imageProps} className={clsx('SDSCircularImage__image', className)} />
    </div>
  );
}
